import React, { useContext, useState } from "react";
import style from "./style.module.scss";
import { Button, Row, Col, Anchor, Icon, Empty, Switch } from "antd";
import moment from "moment";
import QuestionItem from "../../component/questionItem";
import { getQuestionTypeName, QuestionType } from "service/service";
import { TopicType } from "service/homework";
import Widget from "../../component/widget";
import { useHistory } from "react-router-dom";
import FieldTypes from "../../component/FieldTypes";
import { ExamPaperListItem, ExamTimeWay } from "service/exam";
import { previewExamContext } from "../../context";

const { Link } = Anchor;

interface ExamMainPagePCProps {
    examType: string;
    paperName: string;
    score: string;
    startTime: string;
    endTime: string;
    examList: { topicType: QuestionType; list: TopicType[] }[];
    onChangeCheckItem: (val: string) => void; //修改选择项
    examPaperList: ExamPaperListItem[]; //试卷列表
    paperId: string; //试卷id
    PaperListloading: boolean; //多试卷列表加载状态
    timeType: ExamTimeWay; //开考时间, 1统一时间, 2学生自主安排
    duration: string; //考试时限
}

const ExamMainPagePC: React.FC<ExamMainPagePCProps> = ({
    examType,
    paperName,
    score,
    startTime,
    endTime,
    examList,
    onChangeCheckItem,
    examPaperList,
    paperId,
    PaperListloading,
    timeType,
    duration
}) => {
    const [visible, setVisible] = useState(false);

    const history = useHistory();

    const handleSaveTopic = (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string
    ) => {};

    const { setShowAnswer, showAnswer } = useContext(previewExamContext);

    return (
        <div className={style.root}>
            <div className={style.exam}>
                <FieldTypes
                    examPaperList={examPaperList}
                    value={paperId}
                    onChangeCheckItem={onChangeCheckItem}
                    PaperListloading={PaperListloading}
                />
                <div className={style.examHead}>
                    <div className={style.top}>
                        <span>姓名：</span>学生姓名
                        <div className={style.checkRow}>
                            <span>显示答案</span>
                            <Switch
                                className={style.check}
                                checked={showAnswer}
                                onChange={setShowAnswer}
                            />
                        </div>
                    </div>
                    <h1 className={style.title}>{paperName}</h1>
                    <div className={style.subtitle}>
                        满分：{parseFloat(score).toFixed(1)} 分
                    </div>
                    {examType === "1" && (
                        <div className={`${style.subtitle} ${style.red}`}>
                            考试时长：
                            {timeType === ExamTimeWay.unify
                                ? moment(endTime).diff(startTime, "minute")
                                : duration}{" "}
                            分钟
                        </div>
                    )}
                    {examType === "2" && (
                        <div className={`${style.subtitle} ${style.red}`}>
                            截至日期：{endTime}
                        </div>
                    )}
                    {examType === "1" && (
                        <div className={style.answerCard}>
                            <div
                                className={style.answerCardButton}
                                onClick={() => setVisible(!visible)}>
                                答题卡 <Icon type={visible ? "up" : "down"} />
                            </div>
                            {visible && (
                                <Anchor className={style.answerCardList}>
                                    {examList.map(exam => (
                                        <div key={exam.topicType}>
                                            <div
                                                className={
                                                    style.answerCardTitle
                                                }>
                                                {getQuestionTypeName(
                                                    exam.topicType
                                                )}
                                            </div>
                                            <Row>
                                                {exam.list.map(
                                                    (item, index) => (
                                                        <Col
                                                            key={index}
                                                            span={2}
                                                            onClick={() =>
                                                                setVisible(
                                                                    !visible
                                                                )
                                                            }>
                                                            <Link
                                                                key={index}
                                                                title={
                                                                    <div
                                                                        className={
                                                                            style.answerCardItem
                                                                        }>
                                                                        {index +
                                                                            1}
                                                                    </div>
                                                                }
                                                                href={`#${item.topicId}`}
                                                            />
                                                        </Col>
                                                    )
                                                )}
                                            </Row>
                                        </div>
                                    ))}
                                </Anchor>
                            )}
                        </div>
                    )}
                </div>
                {examType === "1" &&
                    examList.map((exam, index) => (
                        <Widget
                            key={index}
                            title={getQuestionTypeName(exam.topicType)}
                            id={exam.topicType}>
                            {exam.list.map((topic, index) => (
                                <div id={topic.topicId} key={topic.topicId}>
                                    <QuestionItem
                                        item={topic}
                                        canPastedText={false}
                                        key={index}
                                        topicId={parseInt(topic.topicId || "0")}
                                        questionIndex={index + 1}
                                        topicType={topic.topicType}
                                        trunk={`${topic.trunk}`}
                                        answers={topic.answers}
                                        homeworkState={1}
                                        onQuestionChange={handleSaveTopic}
                                        contentText={topic.contentText}
                                        score={topic.score.toString()}
                                        topics={topic.topics}
                                    />
                                </div>
                            ))}
                        </Widget>
                    ))}

                {examType === "2" &&
                    examList.map((exam, index) =>
                        exam.list.map(topic => (
                            <Widget
                                key={index}
                                title={topic.trunk}
                                id={topic.topicId}>
                                <QuestionItem
                                    item={topic}
                                    canPastedText={false}
                                    key={index}
                                    topicId={parseInt(topic.topicId || "0")}
                                    topicType={topic.topicType}
                                    trunk={""}
                                    answers={topic.answers}
                                    homeworkState={1}
                                    onQuestionChange={handleSaveTopic}
                                    score={score}
                                    contentText={topic.contentText}
                                />
                            </Widget>
                        ))
                    )}
                {examList.length === 0 && (
                    <Empty description="尚未添加试卷" className={style.empty} />
                )}
            </div>
            <Row className={style.submitButtons}>
                <Col offset={10} span={4}>
                    <Button
                        onClick={() => history.goBack()}
                        className={style.button}
                        size="large"
                        type="primary">
                        返回
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default ExamMainPagePC;
